// extracted by mini-css-extract-plugin
module.exports = {"playerTable":"styles_playerTable___1oj5"};